<template>
  <div class="dashboard-container">
    <div class="back" @click="goToBack">
      <a-icon type="arrow-left"  style="font-size: 18px"/>
    </div>
    <div class="head">
      <div class="head-title">
        <div class="title">{{$t('log.title')}}</div>
        <div class="ms">{{$t('log.title.ms')}}</div>
      </div>
    </div>
    <div class="app-container">
      <a-card :bordered = "false">
        <div>
          <a-tabs default-active-key="1" @change="callback">
            <a-tab-pane key="1" :tab="$t('log.tab.all')">
              <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pageination" @change="change">
                <span slot="requestBody" slot-scope="text, record">
                  {{JSON.parse(text).name}}
                </span>
                <span slot="createAt" slot-scope="text, record">
                  {{timeFormat(text)}}
                </span>
                <span slot="requestStatus" slot-scope="text, record">
                  {{text | statusFilter}}
                </span>
                <span slot="action" slot-scope="text, record">
                  <a @click="submitRepush(record)">Sync</a>
                </span>
              </a-table>
            </a-tab-pane>
            <a-tab-pane key="2" :tab="$t('log.tab.success')" force-render>
              <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pageination" @change="change">
                <span slot="requestBody" slot-scope="text, record">
                  {{JSON.parse(text).name}}
                </span>
                <span slot="createAt" slot-scope="text, record">
                  {{timeFormat(text)}}
                </span>
                <span slot="requestStatus" slot-scope="text, record">
                  {{text | statusFilter}}
                </span>
                <span slot="action" slot-scope="text, record">
                  <a @click="submitRepush">Sync</a>
                </span>
              </a-table>
            </a-tab-pane>
            <a-tab-pane key="3" :tab="$t('log.tab.fail')">
              <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pageination" @change="change">
                <span slot="requestBody" slot-scope="text, record">
                  {{JSON.parse(text).name}}
                </span>
                <span slot="createAt" slot-scope="text, record">
                  {{timeFormat(text)}}
                </span>
                <span slot="requestStatus" slot-scope="text, record">
                  {{text | statusFilter}}
                </span>
                <span slot="action" slot-scope="text, record">
                  <a @click="submitRepush">Sync</a>
                </span>
              </a-table>
            </a-tab-pane>
            <a-tab-pane key="5" :tab="$t('log.tab.to.Sync')">
              <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pageination" @change="change">
                <span slot="requestBody" slot-scope="text, record">
                  {{JSON.parse(text).name}}
                </span>
                <span slot="createAt" slot-scope="text, record">
                  {{timeFormat(text)}}
                </span>
                <span slot="requestStatus" slot-scope="text, record">
                  {{text | statusFilter}}
                </span>
                <span slot="action" slot-scope="text, record">
                  <a @click="submitRepush">Sync</a>
                </span>
              </a-table>
            </a-tab-pane>
            <a-tab-pane key="4" :tab="$t('log.tab.push.today')">
              <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pageination" @change="change">
                <span slot="requestBody" slot-scope="text, record">
                  {{JSON.parse(text).name}}
                </span>
                <span slot="createAt" slot-scope="text, record">
                  {{timeFormat(text)}}
                </span>
                <span slot="requestStatus" slot-scope="text, record">
                  {{text | statusFilter}}
                </span>
                <span slot="action" slot-scope="text, record">
                  <a @click="submitRepush(record)">Sync</a>
                </span>
              </a-table>
            </a-tab-pane>
          </a-tabs>
        </div>
      </a-card>
    </div>
  </div>
</template>

<script>
import { webhookList, repush } from '@/api/api.js'
import { timeParse } from '@/utils/tools.js'
const data = []
const stateMap = {
  0: {
    status: 0,
    text: 'Failed'
  },
  1: {
    status: 1,
    text: 'Synced'
  },
  2: {
    status: 2,
    text: 'To sync'
  }
}
export default {
  name: 'index',
  data () {
    return {
      columns: [
        {
          title: this.$t('log.table.title.webHookName'),
          dataIndex: 'webHookName',
          key: 'webHookName',
          width: 130
        },
        {
          title: this.$t('log.table.title.OrderNO'),
          dataIndex: 'requestBody',
          key: 'requestBody',
          scopedSlots: { customRender: 'requestBody' },
          width: 90
        },
        {
          title: this.$t('log.table.title.createAt'),
          dataIndex: 'createAt',
          key: 'createAt',
          width: 180,
          scopedSlots: { customRender: 'createAt' }
        },
        {
          title: this.$t('log.table.title.requestStatus'),
          dataIndex: 'requestStatus',
          key: 'requestStatus',
          scopedSlots: { customRender: 'requestStatus' },
          width: 80
        },
        {
          title: this.$t('log.table.title.message'),
          key: 'message',
          dataIndex: 'message'
        },
        {
          title: this.$t('log.table.title.action'),
          key: 'action',
          width: 100,
          scopedSlots: { customRender: 'action' }
        }
      ],
      data,
      pageSize: 10,
      pageIndex: 0,
      loading: true,
      pageination: {
        'total': 0,
        'show-total': (e) => { return `Total ${e} items` },
        'pageSize': 10
      },
      tabIndex: 0
    }
  },
  filters: {
    statusFilter (type) {
      return stateMap[type].text
    }
  },
  created () {
    this.getList(0)
  },
  methods: {
    submitRepush (e) {
      let data = JSON.parse(e.requestBody)
      console.log(data)
      repush(data).then(res => {
        if (res.code === 200) {
          this.$message.info('Submitted successfully')
          console.log('this.tabIndex', this.tabIndex)
          this.getList(this.tabIndex)
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('Request failed')
      })
    },
    change (pagination) {
      this.getList(pagination.current - 1)
    },
    timeFormat (e) {
      return timeParse(e)
    },
    callback (e) {
      this.tabIndex = e
      this.getList(0)
    },
    goToBack () {
      this.$router.back()
    },
    getList (index) {
      if (index === 0) {
        this.data = []
      }
      this.loading = true
      let data = {
        'pageSize': this.pageSize,
        'pageIndex': index
      }
      if (this.tabIndex === '2') {
        data.requestStatus = 1
      }
      if (this.tabIndex === '3') {
        data.requestStatus = 0
      }
      if (this.tabIndex === '5') {
        data.requestStatus = 2
      }
      if (this.tabIndex === '4') {
        data.createAt = Date.parse(new Date().toLocaleDateString())
      }
      webhookList(data).then(res => {
        if (res.code === 200) {
          this.data = res.data.content
          this.pageination.total = res.data.totalElements
          this.loading = false
        }
        console.log(res)
      })
    }
  }
}
</script>

<style scoped>
  .dashboard-container {
    max-width: 1290px;
    margin: 0 auto;
    padding: 30px;
  }
  .back {
    width: 36px;
    height: 36px;
    border: 1px solid #d7dbe7;
    background-color:transparent;
    cursor: pointer;
    border-radius: 4px;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .head {
    height: 100px;
    width: 100%;
  }
  .head-title {
    float: left;
  }
  .head .title {
    font-size: 22px;
    font-weight: 700;
    color: black;
  }
  .head .ms {
    font-size: 14px;
    color: #333;
    margin-top: 20px
  }
  .app-container {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/page/send-log/index.vue